import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../../../networking/utils';
import { ChangeEmailWidgetDisplayMode } from './types';

export const setChangeEmailWidgetEmail = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_EMAIL`,
  (email: string) => ({ email })
);

export const setChangeEmailWidgetPassword = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_PASSWORD`,
  (password: string) => ({ password })
);

export const setChangeEmailWidgetOtp = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_OTP`,
  (otp: string) => ({ otp })
);

export const setChangeEmailWidgetDisplayMode = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_DISPLAY_MODE`,
  (displayMode: ChangeEmailWidgetDisplayMode) => ({ displayMode })
);

export const {
  submit: saveChangeEmail,
  success: saveChangeEmailSuccess,
  failure: saveChangeEmailFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_CHANGEEMAIL');
